import { AlunoFrequencia } from "./aluno-frequencia";

export class Frequencia {
  turmaId?: string;
  turmaNome?: string;
  data?: string; 
  alunos?: AlunoFrequencia[];
  catequistas?: string[]; 

  constructor(data?: Partial<Frequencia>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
